enum TipoImagem {
    NoSelected = 'NoSelected',
    EscolherDepois = 'ED',
    Avatar = 'AV',
    Imagem = 'IM',
}

export default TipoImagem;
